import { Attribute } from "../shared/interfaces/Attribute";
import { NewWorkOrder } from "../shared/interfaces/WorkOrder";
import React from "react";
import { KeyValue } from "../ExtraDetails";
import { ExtraDetailsKeys } from "./ExtraDetailsKeys";

export const useUpdateAccessNotes = (
  newWorkorder: Partial<NewWorkOrder>,
  setNewWorkorder: React.Dispatch<React.SetStateAction<Partial<NewWorkOrder>>>,
) => {
  const updateAccessNotes = (substationAttributes?: Attribute[]) => {
    if (!substationAttributes) {
      return;
    }

    const substationAccessNotes = substationAttributes.find((a) => a.key === ExtraDetailsKeys.AccessNotes);
    let extraDetailsAccessNotes = newWorkorder.extraDetail?.find((ed) => ed.key === ExtraDetailsKeys.AccessNotes);

    if (!extraDetailsAccessNotes && substationAccessNotes) {
      addExtraDetailsAccessNotes(substationAccessNotes);
    } else if (
      extraDetailsAccessNotes &&
      substationAccessNotes &&
      extraDetailsAccessNotes.value !== substationAccessNotes.value
    ) {
      updateExtraDetailsAccessNotes(extraDetailsAccessNotes, substationAccessNotes);
    } else if (!substationAccessNotes && extraDetailsAccessNotes) {
      removeExtraDetailsAccessNotes(extraDetailsAccessNotes);
    }
  };

  const addExtraDetailsAccessNotes = (substationAccessNotes: Attribute) => {
    setNewWorkorder((prevState: Partial<NewWorkOrder>) => {
      const extraDetails = [...(prevState.extraDetail || [])];
      extraDetails.push({
        key: substationAccessNotes.key,
        value: substationAccessNotes.value,
      });
      return { ...prevState, extraDetail: extraDetails };
    });
  };

  const updateExtraDetailsAccessNotes = (extraDetailsAccessNotes: KeyValue, substationAccessNotes: Attribute) => {
    extraDetailsAccessNotes.value = substationAccessNotes.value;

    const extraDetails = [...(newWorkorder.extraDetail || [])];
    const detailsIndex = extraDetails.findIndex((detail) => detail.key === extraDetailsAccessNotes.key);

    extraDetails.splice(detailsIndex, 1, extraDetailsAccessNotes);

    setNewWorkorder((prev: Partial<NewWorkOrder>) => {
      return { ...prev, extraDetail: extraDetails };
    });
  };

  const removeExtraDetailsAccessNotes = (extraDetailsAccessNotes: KeyValue) => {
    const extraDetails = [...(newWorkorder.extraDetail || [])];
    const index = extraDetails.findIndex((detail) => detail.key === extraDetailsAccessNotes.key);

    if (index > -1) {
      extraDetails.splice(index, 1);
    }

    setNewWorkorder((prev: Partial<NewWorkOrder>) => {
      return { ...prev, extraDetail: extraDetails };
    });
  };

  return {
    updateAccessNotes,
  };
};
